import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

function ConnectGoogleSuccess() {
    const navigate = useNavigate();

    return (<div className="flex flex-col justify-center items-center mt-[60px]">
        <h1 className="font-bold text-secondary text-[30px] mb-[40px]">🎉 Tài khoản của bạn đã liên kết google thành công! </h1>
        <Button label="Quay lại lớp học" styleButton="w-[200px]" onClick={() => navigate("/class")} />
    </div>);
}

export default ConnectGoogleSuccess;